module.exports = __webpack_public_path__ + "gear.svg?b88f79";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icons/gear.svg
// module id = 256
// module chunks = 0